import { Text } from '@mantine/core';
import { IconBulb } from '@sloyd/icons';
import styles from './Prompt.module.css';
import { Wrapper } from './Prompt.style';

export type PromptProps = {
  prompt: string;
};

export function Prompt(props: PromptProps) {
  const { prompt } = props;

  return (
    <Wrapper className='Prompt-wrapper' data-testid='Prompt-wrapper'>
      <div className={styles.heading}>
        <IconBulb size={24} className={styles.icon} />
        <Text component='h2'>AI Prompt:</Text>
      </div>
      <Text className={styles.content}>{prompt}</Text>
    </Wrapper>
  );
}

export default Prompt;
